import { StandardFieldConfig } from "@/Components/GenericEditor/GenericEditor";
import { MainProduct, Stage, Option, Item } from "@/types/productTypes";

export const mainProductConfig: StandardFieldConfig<MainProduct>[] = [
   { key: "name", label: "Product Name", type: "text" },
   { key: "hide", label: "Hide", type: "switch" },
];

export const stageConfig: StandardFieldConfig<Stage>[] = [
   { key: "header", label: "Stage Name", type: "text" },
   { key: "islandicName", label: "Icelandic Stage Name", type: "text" },
   {
      key: "type",
      label: "Stage Type",
      type: "select",
      options: [
         { value: "item", label: "Item" },
         { value: "threshold", label: "Threshold" },
         { value: "summary", label: "Summary" },
         { value: "offer", label: "Offer" },
      ],
   },
];

export const optionConfig: StandardFieldConfig<Option>[] = [
   { key: "name", label: "Option Name", type: "text" },
   { key: "islandicName", label: "Icelandic Option Name", type: "text" },
   {
      key: "type",
      label: "Option Type",
      type: "select",
      options: [
         { value: "radio", label: "Radio" },
         { value: "checkbox", label: "Checkbox" },
         { value: "summary", label: "Summary" },
         { value: "offer", label: "Offer" },
      ],
   },
];

export const itemConfig: StandardFieldConfig<Item>[] = [
   { key: "name", label: "Item Name", type: "text" },
   { key: "islandicName", label: "Icelandic Item Name", type: "text" },
   { key: "price", label: "Price", type: "number" },
   { key: "notice", label: "Notice", type: "text" },
];
